import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'

import Box from '../Layout/Box'
import BoxButton from '../Layout/BoxButton'
import ButtonStrip from '../Layout/ButtonStrip'

import {
    updateInputs,
    toggleSelectAll,
    storePermisosGrupo
} from '../../actions/grupos'

class PermisosGrupo extends Component {
	render() {
        const { selected, grupo, permisos } = this.props
        if (selected === null) {
            return (
                <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ fontSize: '1.5em', color: 'rgb(187,187,187)', fontStyle: 'italic', fontWeight: '100' }}><FontAwesome name="info-circle" /> Seleccione un grupo para visualizar/modificar sus permisos</p>
                </div>
            )
        }

        const boxActions = [
            <BoxButton key="ba2[0]" name="floppy-o" onClick={ e => this.props.storePermisosGrupo() } title="Guardar"/>,
        ]

		return (
            <div className="col-md-12" style={{ height: '100%' }}>
                <Box title="Permisos del grupo" stretch>
                    <ButtonStrip 
                        actions={ boxActions }
                    />
                    <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                        <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-grupo-permisos">
                            <thead>
                                <tr>
                                    <th style={{ width: '23px' }}>
                                        <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectAll(e.target.checked) } checked={ permisos.filter(x => x.get('selected')).count() === permisos.count() } />
                                    </th>
                                    <th>Permiso</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    permisos.count() > 0 ? permisos.map((x, n) => {
                                        return (
                                            <tr key={ `tr2[${x.get('id')}]` } className={ x.get('selected') ? 'info' : '' }>
                                                <td>
                                                    <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.updateInputs(`permisosGrupo.${n}.selected`, e.target.checked) } checked={ x.get('selected') || false } />
                                                </td>
                                                <td>{ x.get('nombre') }</td>
                                            </tr>
                                        )
                                    }) : <tr><td colSpan={ 2 }>No existen registros</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Box>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        selected: state.grupos.get('selected'),
        grupo: state.grupos.getIn(['grupos',String(state.grupos.get('selected'))]),
        permisos: state.grupos.get('permisosGrupo')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value, false)),
        toggleSelectAll: (checked) => dispatch(toggleSelectAll(checked)),
        storePermisosGrupo: () => dispatch(storePermisosGrupo()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PermisosGrupo)


// WEBPACK FOOTER //
// ./src/components/Grupos/PermisosGrupo.jsx